import { PanelBroadcast, RegionalBroadcastTeam } from '../../../../types';

export const getNetworksListFromTeam = (team?: RegionalBroadcastTeam): Array<string> =>
    team?.broadcasters?.map?.(({ network }: PanelBroadcast) => network as string) || [];
